import { TaxIdentifier } from '@dreryk/tax-identifier-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { TaxIdentifierInput } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../translations';

const TAX_IDENTIFIER_FIELD_NAME = 'taxIdentifier';

export type TaxIdentifierFormBeanPart = {
   [TAX_IDENTIFIER_FIELD_NAME]: TaxIdentifier;
};

type TaxIdentifierFieldProps = {
   readonly register: BindingCreator<TaxIdentifierFormBeanPart, typeof TAX_IDENTIFIER_FIELD_NAME>;
   readonly disabled?: boolean;
};

export const TaxIdentifierField = (props: TaxIdentifierFieldProps): JSX.Element => {
   return (
      <TaxIdentifierInput
         controller={props.register(TAX_IDENTIFIER_FIELD_NAME, {
            required: true,
            /*
             * TODO: DREGAB-19275 - Poprawa walidacji tak by populowała walidacje z wnętrza komponentu
             * react-components i nie trzeba było ich powtarzać ponownie podczas rejestracji pola
             */
            minLength: {
               value: TaxIdentifier.NORMALIZED_VALUE_LENGTH,
               message: invoiceSharedComponentsTranslationKeys.taxIdentifier.minLength,
            },
            maxLength: TaxIdentifier.NORMALIZED_VALUE_LENGTH,
            validate: (value) => {
               const taxIdentifier = value as string | undefined;

               if (!TaxIdentifier.isValid(taxIdentifier)) {
                  return invoiceSharedComponentsTranslationKeys.taxIdentifier.invalid;
               }

               return undefined;
            },
         })}
         testId={TAX_IDENTIFIER_FIELD_NAME}
         disabled={props.disabled}
      />
   );
};
